/**
 * Promotional sponsor (role `advertiser`) — Firestore canonical doc per user:
 * `advertiserCarouselSponsorships/{uid}`
 *
 * Config uses `geographicTargetingGroups[]` (zip sets + slides + optional `sponsorDisplayName` per group).
 * Zip listings after approval: `zips/{zip}/listings/lc_sponsor_{uid}` or `lc_sponsor_{uid}_{groupId}`
 * (Cloud Function only). Legacy flat `zipCodes` / `slides` are migrated on read.
 */

export const ADVERTISER_CAROUSEL_SPONSORSHIP_COLLECTION =
  "advertiserCarouselSponsorships";

export const ADVERTISER_CAROUSEL_REVIEW_DRAFT = "draft";
export const ADVERTISER_CAROUSEL_REVIEW_PENDING = "pending";
export const ADVERTISER_CAROUSEL_REVIEW_REJECTED = "rejected";
export const ADVERTISER_CAROUSEL_REVIEW_APPROVED = "approved";

/** @type {Record<string, string>} */
export const ADVERTISER_CAROUSEL_REVIEW_LABELS = {
  [ADVERTISER_CAROUSEL_REVIEW_DRAFT]: "Draft — not submitted",
  [ADVERTISER_CAROUSEL_REVIEW_PENDING]: "Pending review",
  [ADVERTISER_CAROUSEL_REVIEW_REJECTED]: "Rejected — edit and resubmit",
  [ADVERTISER_CAROUSEL_REVIEW_APPROVED]: "Approved — live on map (if subscribed)",
};
